import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Zap, Package, Infinity } from 'lucide-react';
const principles = [{
  icon: Wrench,
  title: 'ใช้งานได้จริง ไม่ใช่ทฤษฎี',
  description: 'ทุกหน้าคือเครื่องมือที่พร้อมใช้ในคลาสของคุณวันนี้ ไม่ใช่คู่มือวิชาการ'
}, {
  icon: Zap,
  title: 'เริ่มใช้ได้ทันที',
  description: 'ไม่ต้องเรียนรู้ซอฟต์แวร์ ไม่ต้องผ่านการอบรม เปิด PDF แล้วสอนได้เลย'
}, {
  icon: Package,
  title: 'ครบทุกด้าน',
  description: 'ครอบคลุมทุกพื้นที่: แผนการสอน ยุทธวิธี การประเมิน การจัดการทีม และการสื่อสารกับผู้ปกครอง'
}, {
  icon: Infinity,
  title: 'เป็นของคุณตลอดไป',
  description: 'ชำระครั้งเดียว ไม่มีค่าสมาชิก ใช้เมื่อไหร่ก็ได้ บนทุกอุปกรณ์'
}];
export function WhyDifferent() {
  return <section className="w-full bg-cream-alt py-20 px-4" data-id="element-276">
      <div className="max-w-6xl mx-auto" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-278">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-navy-primary mb-4" data-id="element-279">
            ทำไมระบบนี้ถึงแตกต่าง
          </h2>
          <p className="text-xl text-gray-700" data-id="element-280">
            ไม่มีทฤษฎี ไม่มีสมาชิกรายเดือน ไม่ต้องจ้างที่ปรึกษา
            มีแต่เครื่องมือพร้อมใช้
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-281">
          {principles.map((principle, index) => {
          const Icon = principle.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} whileHover={{
            y: -5
          }} className="bg-white rounded-xl p-8 shadow-lg border border-gold-accent/20" data-id="element-282">
                <div className="w-14 h-14 bg-gold-accent/10 rounded-xl flex items-center justify-center mb-4" data-id="element-283">
                  <Icon className="w-7 h-7 text-gold-accent" data-id="element-284" />
                </div>
                <h3 className="text-xl font-display font-bold text-navy-primary mb-3" data-id="element-285">
                  {principle.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-286">
                  {principle.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}